module.exports = __webpack_public_path__ + "img/logo-only.aaa400fb.png";